import React,{useRef} from 'react';
import { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from "../components/header";
import Float from "../components/float";
import Footer from "../components/footer";

import Info from "../components/update/info";

export default class Update extends Component {
    constructor(props){
        super(props)

        this.state = {
            name: '',
            user:[],
            address: [],
            formUpdate:{
                name:'',
                lastname:'',
                identy:'',
                mail:'',
                password:'',
                password_new:'',
                phone:'',
                address:'',
                town:'',
                token:'',
                country_id:'',
                state_id:'',
                city_id:'',
            },
            cities:[],
            addressList:[],
            formAddress:{
                id:'',
                password:'',
                address:'',
                town:'',
                token:'',
                country_id:'',
                state_id:'',
                city_id:'',
                description:''
            },
            formAddressAdd:{
                id:'',
                password:'',
                address:'',
                town:'',
                token:'',
                country_id:'',
                state_id:'',
                city_id:'',
                description:''
            },
            error: null,
            brands:[],
            brands_2:[],
            categories:[],
            info:[],
        }
        
        this.formUpdateSubmit = this.formUpdateSubmit.bind(this)
        this.handleChangeFormUpdate = this.handleChangeFormUpdate.bind(this)
        this.onChangeCity = this.onChangeCity.bind(this)
        this.clickFormUpdate = this.clickFormUpdate.bind(this)
        
        //address
        this.onSubmitAddress = this.onSubmitAddress.bind(this);
        this.handleChangeFormAddress = this.handleChangeFormAddress.bind(this);
        this.onChangeAddressCity = this.onChangeAddressCity.bind(this);

        this.selectAddress = this.selectAddress.bind(this);

        this.onSubmitAddressAdd = this.onSubmitAddressAdd.bind(this);
        this.onChangeAddressAdd = this.onChangeAddressAdd.bind(this);
        this.onChangeAddressCityAdd = this.onChangeAddressCityAdd.bind(this);
    }

    //update_form started
    handleChangeFormUpdate(e){
        this.setState({
            formUpdate:{
                ...this.state.formUpdate,
                [e.target.name]:e.target.value
            }
        })
    }

    onChangeCity(e){
        this.setState({city: e.target.value});
        this.setState({
            formUpdate:{
                ...this.state.formUpdate,
                city_id:e.target.value,
            }
        });
    }

    clickFormUpdate(){
        $('#clickSubmit').click();
    }

    formUpdateSubmit = async (e) => {
        e.preventDefault()
        if(
            this.state.formUpdate.name == '' ||
            this.state.formUpdate.lastname == '' ||
            this.state.formUpdate.identy == '' ||
            this.state.formUpdate.mail == '' ||
            this.state.formUpdate.phone == '' ||
            this.state.formUpdate.address == ''||
            this.state.formUpdate.town == '' ||
            this.state.formUpdate.city_id == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        try{
            let configUpdate = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formUpdate)
            }
            let resUpdate = await fetch(`${https}api/update`,configUpdate)
            let dataUpdate = await resUpdate.json()
            if(dataUpdate == 1){
                swal.close();
                swal({
                    text: "Gracias por actualizar tus datos",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                        } else {
                            
                        }
                    });
            }else if(dataUpdate == 2) {
                swal({
                    text: "Este correo ya se encuentra registrado",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataUpdate == 3) {
                swal({
                    text: "Para actualizar sus datos ingrese la contraseña correcta",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    //update_form finished

    //address_form started
    handleChangeFormAddress(e){
        this.setState({
            formAddress:{
                ...this.state.formAddress,
                [e.target.name]:e.target.value
            }
        })
    }

    onChangeAddressCity(e){
        this.setState({
            formAddress:{
                ...this.state.formAddress,
                city_id:e.target.value,
            }
        });
    }

    onSubmitAddress = async (e) => {
        e.preventDefault()
        if(
            this.state.formAddress.password == '' ||
            this.state.formAddress.address == ''||
            this.state.formAddress.town == '' ||
            this.state.formAddress.city_id == '' ||
            this.state.formAddress.description == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        try{
            let configAddress = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formAddress)
            }
            let resAddress = await fetch(`${https}api/addressListUpdateGo`,configAddress)
            let dataAddress = await resAddress.json()
            if(dataAddress == 1){
                this.setState({
                    formAddress:{
                        id:'',
                        password:'',
                        address:'',
                        town:'',
                        token:'',
                        country_id:'',
                        state_id:'',
                        city_id:'',
                        description:''
                    },
                })
                swal.close();
                document.getElementById("formAddress").reset();
                $("#formAddress")[0].reset();
                swal({
                    text: "Gracias por actualizar la direccion",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            location.reload();
                        } else {

                        }
                    });
            }else if(dataAddress == 2){
                swal({
                    text: "Contraseña incorrecta, no se ha podido actualizar la dirreción",
                    icon: "warning",
                    button: "ok",
                });
            }else{
                alert('ocurrio un error');
                /*setTimeout(function (){
                    location.reload();
                },1000)*/
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    //address_form finished

    selectAddress = async (id) =>{
        try{
            fetch(https+'api/addressListUpdate/'+id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        formAddress:{
                            id: data.id,
                            password:'',
                            address:data.address,
                            town:data.town,
                            token:'',
                            country_id:'',
                            state_id:'',
                            city_id:data.city,
                            description:data.description
                        },
                    })
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    //address_add_form started
    onChangeAddressAdd(e){
        this.setState({
            formAddressAdd:{
                ...this.state.formAddressAdd,
                [e.target.name]:e.target.value
            }
        })
    }

    onChangeAddressCityAdd(e){
        this.setState({
            formAddressAdd:{
                ...this.state.formAddressAdd,
                city_id:e.target.value,
            }
        });
    }

    onSubmitAddressAdd = async (e) => {
        e.preventDefault()
        if(
            this.state.formAddressAdd.password == '' ||
            this.state.formAddressAdd.address == ''||
            this.state.formAddressAdd.town == '' ||
            this.state.formAddressAdd.city_id == '' ||
            this.state.formAddressAdd.description == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        try{
            let configAddressAdd = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formAddressAdd)
            }
            let resAddressAdd = await fetch(`${https}api/addressListAdd`,configAddressAdd)
            let dataAddressAdd = await resAddressAdd.json()
            if(dataAddressAdd == 1){
                this.setState({
                    formAddressAdd:{
                        id:'',
                        password:'',
                        address:'',
                        town:'',
                        token:'',
                        country_id:'',
                        state_id:'',
                        city_id:'',
                        description:''
                    },
                })
                swal.close();
                document.getElementById("formAddressAdd").reset();
                $("#formAddressAdd")[0].reset();
                swal({
                    text: "Gracias por agregar la direccion",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            location.reload();
                        } else {

                        }
                    });
            }else if(dataAddressAdd == 2){
                swal({
                    text: "Contraseña incorrecta, no se ha podido agregar la dirreción",
                    icon: "warning",
                    button: "ok",
                });
            }else{
                alert('ocurrio un error');
                /*setTimeout(function (){
                    location.reload();
                },1000)*/
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    //address_form finished
    

    async componentDidMount(){
        //user
        try{
            let res = await fetch(https+'api/user/'+userId)
            let data = await res.json()
            this.setState({
                user:data,
                formUpdate:{
                    ...this.state.formUpdate,
                    name:data.name,
                    lastname:data.lastname,
                    identy:data.identy,
                    mail:data.mail,
                    phone:data.phone,
                },
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //address
        try{
            let res = await fetch(https+'api/address/'+userId)
            let data = await res.json()
            this.setState({
                address:data,
                formUpdate:{
                    ...this.state.formUpdate,
                    address:data.address,
                    town:data.town,
                    country_id:data.country,
                    state_id:data.state,
                    city_id:data.city,
                },
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //address
        try{
            let res = await fetch(https+'api/addressList')
            let data = await res.json()
            this.setState({
                addressList:data,
            })
            this.setState({
                formAddress:{
                    id: data[0].id,
                    password:'',
                    address:data[0].address,
                    town:data[0].town,
                    token:'',
                    country_id:'',
                    state_id:'',
                    city_id:data[0].city,
                    description:data[0].description
                },
            })
        }catch (error) {
            this.setState({
                error
            })
        }



        //informacion
        try{
            let res = await fetch(https+'api/info')
            let data = await res.json()
            this.setState({
                info:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands
        try{
            let res = await fetch(https+'api/brandsHeader')
            let data = await res.json()
            this.setState({
                brands:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands 2
        try{
            let res = await fetch(https+'api/brandsHeader2')
            let data = await res.json()
            this.setState({
                brands_2:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //categories
        try{
            let res = await fetch(https+'api/categoriesHeader')
            let data = await res.json()
            this.setState({
                categories:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //city
        try{
            let res = await fetch(https+'api/cities')
            let data = await res.json()
            this.setState({
                cities:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }

    }
    
    render() {
        return (
            <div>
                <Header
                    brands={this.state.brands}
                    brands_2={this.state.brands_2}
                    categories={this.state.categories}
                />
                <Info
                    user={this.state.user}
                    address={this.state.address}
                    cities={this.state.cities}
                    onChange={this.handleChangeFormUpdate}
                    onSubmit={this.formUpdateSubmit}
                    onChangeCity={this.onChangeCity}
                    form={this.state.formUpdate}
                    click={this.clickFormUpdate}

                    addressList={this.state.addressList}

                    onSubmitAddress={this.onSubmitAddress}
                    formAddress={this.state.formAddress}
                    onChangeAddress={this.handleChangeFormAddress}
                    onChangeAddressCity={this.onChangeAddressCity}

                    selectAddress={this.selectAddress}

                    onSubmitAddressAdd={this.onSubmitAddressAdd}
                    formAddressAdd={this.state.formAddressAdd}
                    onChangeAddressAdd={this.onChangeAddressAdd}
                    onChangeAddressCityAdd={this.onChangeAddressCityAdd}
                />
                <Float
                    info={this.state.info}
                />
                <Footer
                    info={this.state.info}
                />
            </div>
        );
    }

}

if (document.getElementById('content_update')) {
    ReactDOM.render(<Update />, document.getElementById('content_update'))
}
